import { SIGNATURE_TYPE } from 'common/utils/signature/signatureTypes';
import { SIGNATURE_MODE } from 'common/utils/signature/signatureModes';

/** Champs électroniques remis à zéro quand on (re)passe en signature manuelle. */
export const resetElectronicSignatureFields = () => ({
    universignTransaction: null,
    universignTransactionState: null,
    universignTransactionFailureAdvisorMailSent: null,
    initiateSignatureAdvisor: null,
});

/** Champ manuel remis à zéro quand on (re)passe en signature électronique. */
export const resetManualSignatureField = (signer) => {
    if ('client' === signer) {
        return { signature: null };
    }
    if ('partner' === signer) {
        return { partnerSignature: null };
    }

    return {};
};

const addManualSigner = (current, signer, online) => {
    const next = { ...current, [signer]: { type: SIGNATURE_TYPE.MANUAL, date: Date.now() } };

    return online ? next : { ...next, offLine: true };
};

/** Ajoute une entrée électronique (démarrage de transaction) pour un signataire. */
export const addElectronicSigner = (current, signer) => (
    { ...current, [signer]: { type: SIGNATURE_TYPE.ELECTRONIC_PENDING, date: Date.now() } }
);

/** Marque un signataire comme ayant refusé la signature électronique. */
export const refuseElectronicSigner = (current, signer) => (
    { ...current, [signer]: { type: SIGNATURE_TYPE.ELECTRONIC_REFUSED } }
);

/**
 * Reconstruit `clientAndPartnerSignatureDate` après des signatures manuelles,
 * à partir de l'état du RIP et des modes choisis. Reproduit à l'identique la
 * logique qui était dans le useEffect de ManualSignatures.
 */
export const buildManualSignatureTimeAndType = (rip, {
    hasPartner,
    clientSignatureMode,
    partnerSignatureMode,
    online,
}) => {
    let result = rip.clientAndPartnerSignatureDate;

    if (rip.signature && SIGNATURE_MODE.NONE !== clientSignatureMode) {
        result = addManualSigner(result, 'client', online);
    }
    if (hasPartner && rip.partnerSignature && SIGNATURE_MODE.NONE !== partnerSignatureMode) {
        result = addManualSigner(result, 'partner', online);
    }

    return result;
};
